 const contacts = {
  state: {
    therapists: null,
    therapistsLoaded: false,
  },
  mutations: {
    setTherapists(state, data) {
      state.therapists = data;
      state.therapistsLoaded = true;
    }
  },
  getters: {
    therapists: state => {
      return state.therapists;
    },
    isTherapistsLoaded: state => {
      return state.therapistsLoaded;
    }
  },
};

 export default contacts;
